import React from 'react';

const SelectFileSvg = ({show}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
            <path
                d="M9.66634 0.666748H1.66634C0.933008 0.666748 0.333008 1.26675 0.333008 2.00008V11.3334H1.66634V2.00008H9.66634V0.666748ZM8.99967 3.33341H4.33301C3.59967 3.33341 3.00634 3.93341 3.00634 4.66675L2.99967 14.0001C2.99967 14.7334 3.59301 15.3334 4.32634 15.3334H11.6663C12.3997 15.3334 12.9997 14.7334 12.9997 14.0001V7.33342L8.99967 3.33341ZM4.33301 14.0001V4.66675H8.33301V8.00008H11.6663V14.0001H4.33301Z"
                fill={show ? "#FD6A16" : "#FFF"}/>
        </svg>
    );
};

export default SelectFileSvg;